import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, EventEmitter } from "@angular/core";
import { GlobalsService } from "./globals";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";

@Injectable()
export class ProcessService {
  public onClick$: EventEmitter<boolean>;
  public loading$: EventEmitter<boolean>;
  public process_selected: number;

  constructor(private http: HttpClient, private globals: GlobalsService) {
    this.onClick$ = new EventEmitter<boolean>();
    this.loading$ = new EventEmitter<boolean>();
  }

  private header(): HttpHeaders {
    return new HttpHeaders({
      Authorization: "Bearer " + this.globals.user.token,
      Accept: "application/json",
      "Content-Type": "application/json",
    });
  }

  listProcess(): Observable<any> {
    const apiUrl = `${this.globals.apiUrl}/api/caracterizacion-proceso`;
    return this.http.get(apiUrl);
  }

  public updateProcessCharacter(body): Observable<any> {
    return this.http.put(
      environment.apiUrl + "/api/caracterizacion-proceso/" + body.id,
      body,
      {
        headers: this.header(),
      }
    );
  }

  public createProcessCharacter(body): Observable<any> {
    return this.http.post(
      environment.apiUrl + "/api/caracterizacion-proceso",
      body,
      {
        headers: this.header(),
      }
    );
  }

  public getProcess(): Observable<any> {
    return this.http.get(`${this.globals.apiUrl}/api/caracterizacion-proceso`, {
      headers: this.header(),
    });
  }

  public getOne(id: Number) {
    return this.http.get(`${this.globals.apiUrl}/api/proceso/${id}`, {
      headers: this.header(),
    });
  }

  public getOneProcess(id: Number) {
    return this.http.get(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}`,
      {
        headers: this.header(),
      }
    );
  }

  public associateProcces(id, process) {
    return this.http.post(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/relacionar-proceso`,
      process,
      { headers: this.header() }
    );
  }

  public getAssociatedProcceses(id) {
    return this.http.get(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/proceso-relacionado`,
      { headers: this.header() }
    );
  }

  public getProccesTags(id) {
    return this.http.get(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/etiqueta`,
      { headers: this.header() }
    );
  }

  public createTagProcces(id, params) {
    return this.http.post(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/etiqueta`,
      params,
      { headers: this.header() }
    );
  }

  public attachToResourceForCharacterization(id_process, params) {
    return this.http.post(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id_process}/recurso`,
      params,
      { headers: this.header() }
    );
  }

  public getAttachedResourcesForCharacterization(id_process) {
    return this.http.get(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id_process}/recurso`,
      { headers: this.header() }
    );
  }

  public attachToResourceForTags(id_process, id_tag, params) {
    return this.http.post(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id_process}/etiqueta/${id_tag}/recurso`,
      params,
      { headers: this.header() }
    );
  }

  public getAttachedResourcesForTags(id_process, id_tag) {
    return this.http.get(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id_process}/etiqueta/${id_tag}/recurso`,
      { headers: this.header() }
    );
  }

  public createNewProcess(params) {
    return this.http.post(`${this.globals.apiUrl}/api/proceso`, params, {
      headers: this.header(),
    });
  }

  public createNewMapProcess(id, params) {
    return this.http.post(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/mapa-proceso`,
      params,
      {
        headers: this.header(),
      }
    );
  }

  public getMapProcess(id) {
    return this.http.get(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/mapa-proceso`,
      { headers: this.header() }
    );
  }

  public documentedInformationAttachment(id, params) {
    console.log("una");

    return this.http.post(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/informacion-documentada`,
      params,
      { headers: this.header() }
    );
  }

  public getDocumentedInformationAttachment(id) {
    return this.http.get(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/informacion-documentada`,
      { headers: this.header() }
    );
  }

  public approveProcessCharacter(id, body) {
    return this.http.put(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/aprobar`,
      body,
      { headers: this.header() }
    );
  }

  public notApproveProcessCharacter(id) {
    return this.http.put(
      `${this.globals.apiUrl}/api/caracterizacion-proceso/${id}/no-aprobar`,
      { headers: this.header() }
    );
  }
  public getPdf(id: string | number, idToolbox: string | number = 5) {
    return this.http.get(
      `${this.globals.apiUrl}/api/reporte/toolbox/${idToolbox}/caracterizacion-proceso/${id}/declaracion`,
      {
        headers: this.header(),
        responseType: "blob",
      }
    );
  }
}
